module.exports = __webpack_public_path__ + "img/01038.c5ed5e66.png";